export default "__VITE_ASSET__C_pEeq87__"